export default "__VITE_ASSET__CIiJiAo9__"